import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import GameService from '../../service/game/GameService';
import { Helmet } from 'react-helmet-async';

const GameSharePage = () => {
  const { gameId } = useParams();
  const [game, setGame] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAndStart = async () => {
      if (!gameId) return;

      try {
        const res = await GameService.list();
        const list = res?.data?.list || [];

        const matched = list.find((g: any) => g.game_id === Number(gameId));
        if (!matched) {
          console.error('해당 gameId에 해당하는 게임이 없습니다.');
          return;
        }

        const startRes = await GameService.startPlay(matched.game_id);
        const { play_id, player_id } = startRes.data;

        const matchRes = await GameService.getMatch(
          matched.game_id,
          play_id,
          1,
          player_id,
        );

        navigate('/game/detail', {
          state: {
            gameData: matched,
            matchData: matchRes,
            playId: play_id,
            playerId: player_id,
            title: matched.title,
          },
        });
      } catch (e) {
        console.error('[공유 페이지 진입 후 자동 시작 실패]', e);
      }
    };

    fetchAndStart();
  }, [gameId, navigate]);

  return (
    <>
      <Helmet>
        <title>땅집고옥션 ｜ {game?.title || '공유된 경매 게임'}</title>
        <meta
          property="og:title"
          content={`땅집고옥션 ｜ ${game?.title || ''}`}
        />
        <meta
          property="og:description"
          content={
            game?.description || '경매 투자 밸런스 게임 - 어떤 물건이 우승할까?'
          }
        />
        <meta
          property="og:image"
          content={`${window.location.origin}/assets/images/game/game_share.png`}
        />
        <meta property="og:url" content={window.location.href} />
      </Helmet>
    </>
  );
};

export default GameSharePage;
